import Subpanel from './Subpanel/index';

export {
  Subpanel,
};


// WEBPACK FOOTER //
// ./src/components/page/DetailsSubpanels/components/index.js